import React, { useState } from 'react';
import { Menu, X, ArrowRight } from 'lucide-react';

interface NavbarProps {
  onOpenConsultation: () => void;
}

export const Navbar: React.FC<NavbarProps> = ({ onOpenConsultation }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="site-header" style={{
      position: 'sticky',
      top: 0,
      zIndex: 50,
      backgroundColor: 'rgba(255, 255, 255, 0.96)',
      backdropFilter: 'blur(16px)',
      borderBottom: '1px solid var(--border-color)',
      transition: 'all 0.3s ease'
    }}>
      <div className="container" style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '76px'
      }}>
        {/* Brand Logo */}
        <a href="#" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none' }}>
          <img src="/brand/social.png" alt="" width="46" height="46" style={{ borderRadius: 10 }} />
          <div>
            <span style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '1.25rem',
              fontWeight: 800,
              letterSpacing: '0.04em',
              color: '#0F172A'
            }}>
              EVERFORGE
            </span>
            <span style={{
              display: 'block',
              fontSize: '0.65rem',
              fontWeight: 700,
              letterSpacing: '0.15em',
              color: 'var(--accent-amber)',
              marginTop: '-3px'
            }}>
              FITNESS
            </span>
          </div>
        </a>

        {/* Desktop Navigation Links */}
        <nav style={{
          display: 'none',
          alignItems: 'center',
          gap: '2rem'
        }} className="desktop-nav">
          <a href="#philosophy" style={{ fontSize: '0.9rem', fontWeight: 600, color: 'var(--text-secondary)', transition: 'color 0.2s', textDecoration: 'none' }}>Our approach</a>
          <a href="#plans" style={{ fontSize: '0.9rem', fontWeight: 600, color: 'var(--text-secondary)', transition: 'color 0.2s', textDecoration: 'none' }}>Coaching Plans</a>
          <a href="#pricing" style={{ fontSize: '0.9rem', fontWeight: 600, color: 'var(--text-secondary)', transition: 'color 0.2s', textDecoration: 'none' }}>Pricing</a>
          <a href="#faq" style={{ fontSize: '0.9rem', fontWeight: 600, color: 'var(--text-secondary)', transition: 'color 0.2s', textDecoration: 'none' }}>FAQ</a>
        </nav>

        {/* Action Buttons */}
        <div style={{ display: 'none', alignItems: 'center', gap: '1rem' }} className="desktop-actions">
          <a
            href="https://everforge.web.app"
            target="_blank"
            rel="noopener noreferrer"
            title="Opens the live EVERFORGE Coaching Application"
            style={{
              fontSize: '0.85rem',
              fontWeight: 600,
              color: 'var(--text-secondary)',
              padding: '0.6rem 1rem',
              borderRadius: 'var(--radius-full)',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: '0.35rem'
            }}
          >
            <span>Client Login ↗</span>
          </a>
          <button
            onClick={onOpenConsultation}
            className="btn-primary"
            style={{ padding: '0.65rem 1.4rem', fontSize: '0.9rem' }}
          >
            Let’s talk <ArrowRight size={16} />
          </button>
        </div>

        {/* Mobile Hamburger Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{
            display: 'block',
            color: 'var(--text-primary)',
            padding: '0.5rem',
            background: 'none',
            border: 'none',
            cursor: 'pointer'
          }}
          className="mobile-toggle"
          aria-label="Toggle navigation"
        >
          {mobileMenuOpen ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div style={{
          backgroundColor: 'var(--bg-surface)',
          borderBottom: '1px solid var(--border-color)',
          padding: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.25rem'
        }}>
          <a
            href="#philosophy"
            onClick={() => setMobileMenuOpen(false)}
            style={{ fontSize: '1rem', fontWeight: 600, color: 'var(--text-primary)', textDecoration: 'none' }}
          >
            Our approach
          </a>
          <a
            href="#plans"
            onClick={() => setMobileMenuOpen(false)}
            style={{ fontSize: '1rem', fontWeight: 600, color: 'var(--text-primary)', textDecoration: 'none' }}
          >
            Coaching Plans
          </a>
          <a
            href="#pricing"
            onClick={() => setMobileMenuOpen(false)}
            style={{ fontSize: '1rem', fontWeight: 600, color: 'var(--text-primary)', textDecoration: 'none' }}
          >
            Pricing
          </a>
          <a
            href="#faq"
            onClick={() => setMobileMenuOpen(false)}
            style={{ fontSize: '1rem', fontWeight: 600, color: 'var(--text-primary)', textDecoration: 'none' }}
          >
            FAQ
          </a>
          <hr style={{ borderColor: 'var(--border-color)', margin: '0.5rem 0' }} />
          <a
            href="https://everforge.web.app"
            target="_blank"
            rel="noopener noreferrer"
            title="Opens the live EVERFORGE Coaching Application"
            style={{ fontSize: '0.95rem', color: 'var(--text-secondary)', textDecoration: 'none' }}
          >
            Client Login ↗
          </a>
          <button
            onClick={() => {
              setMobileMenuOpen(false);
              onOpenConsultation();
            }}
            className="btn-primary"
            style={{ width: '100%' }}
          >
            Let’s talk <ArrowRight size={16} />
          </button>
        </div>
      )}

      <style>{`
        @media (min-width: 1180px) {
          .desktop-nav { display: flex !important; }
          .desktop-actions { display: flex !important; }
          .mobile-toggle { display: none !important; }
        }
      `}</style>
    </header>
  );
};
